import { render, staticRenderFns } from "./userDetail2.vue?vue&type=template&id=16b57b44&scoped=true&"
import script from "./userDetail2.vue?vue&type=script&lang=js&"
export * from "./userDetail2.vue?vue&type=script&lang=js&"
import style0 from "./userDetail2.vue?vue&type=style&index=0&id=16b57b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b57b44",
  null
  
)

export default component.exports